import styles from "./productdetails.module.css";
import { Outlet, useLocation, useParams } from "react-router-dom";
import {
  useSingleProductQuery,
} from "../../../queries/useProductsQuery";

import ProductImage from "./ProductImage";
import ProductInfo from "./ProductInfo";
import ProductTabs from "./ProductTabs";
import RelatedProducts from "./RelatedProducts";
import { Banner, BreadCrumb } from "../../../components/shared/index";
import { useAddToCart } from "../../../queries/useCartQuery";

const ProductDetails = () => {
  const { productSlug } = useParams();
  const { pathname } = useLocation();

  const parts = pathname.split("/");
  const newPath = parts[parts.length - 2];

 const {
  data: productData,
  isPending: isSingleProductLoading,
  isError,
  error,
  isFetching,
} = useSingleProductQuery(productSlug);

// ✅ Related products are included in productData
const relatedProducts = productData?.related_products || [];

  const { mutate: addToCart, isPending: isCartPending } = useAddToCart();

  const images = productData
    ? [
        productData.thumb_image
          ? {
              image: productData.thumb_image,
              isThumb: true,
            }
          : null,

        ...(productData.product_image_galleries || []),
      ].filter(Boolean)
    : [];

  

  return (
    <section className={styles.productDetailsMain}>
      <BreadcrumbBanner
        productData={productData}
        imageUrl="/assets/img/products/banner_2.png"
        heading="Your trusted choice for fresh, healthy, and affordable groceries"
      />

      <div className={styles.detailsWrapper}>
        <ProductImage
          images={images}
          productId={productData?.id}
          productName={productData?.name}
          isPending={isSingleProductLoading}
          isError={isError}
          error={error}
        />

        <ProductInfo
          productData={productData}
          addToCart={addToCart}
          isPending={isSingleProductLoading}
          isCartPending={isCartPending}
          isError={isError}
          error={error}
        />
      </div>

      <ProductTabs
        productData={productData}
        isPending={isSingleProductLoading}
        isFetching={isFetching}
      />

      <Outlet />

      {/* ✅ API related_products displayed here */}
      <RelatedProducts
        relatedProducts={relatedProducts}
        isPending={isSingleProductLoading}
      />
    </section>
  );
};

const BreadcrumbBanner = ({ productData, imageUrl, heading }) => {
  const categoryName = productData?.category?.name;
  const categorySlug = productData?.category?.slug;

  const subCategoryName =
    productData?.subcategory?.name ||
    productData?.sub_category?.name;

  const subCategorySlug =
    productData?.subcategory?.slug ||
    productData?.sub_category?.slug;

  const childCategoryName = productData?.child_category?.name;
  const childCategorySlug = productData?.child_category?.slug;

  const customPaths = [
    { label: "Shop", path: "/shop" },
  ];

  if (categoryName && categorySlug) {
    customPaths.push({
      label: categoryName,
      path: `/shop/${categorySlug}`,
    });
  }

  if (subCategoryName && subCategorySlug) {
    customPaths.push({
      label: subCategoryName,
      path: `/shop/${categorySlug}/${subCategorySlug}`,
    });
  }

  if (childCategoryName && childCategorySlug) {
    customPaths.push({
      label: childCategoryName,
      path: `/shop/${categorySlug}/${subCategorySlug}/${childCategorySlug}`,
    });
  }

  if (productData?.name && productData?.slug) {
    customPaths.push({
      label: productData.name,
      path: window.location.pathname,
    });
  }

  return (
    <>
      <BreadCrumb customPaths={customPaths} />

      <Banner
        heading={heading || "Product Details"}
        imageUrl={imageUrl}
      />
    </>
  );
};

export default ProductDetails;